import { createApp } from 'vue'
import axios from 'axios'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import { createMetaManager } from 'vue-meta'

axios.defaults.withCredentials = true
axios.defaults.baseURL = process.env.VUE_APP_SERVER_URL

loadFonts()

createApp(App)
  .use(createMetaManager())
  .use(router)
  .use(store)
  .use(vuetify)
  .mount('#app')
